// src/config/buildInfo.js
// Which frontend build this is, shown in the admin footer. The deploy workflow stamps the commit and
// build time; `npm start` and hand-made builds have neither.
export const FRONTEND_COMMIT = process.env.REACT_APP_GIT_SHA || null;
export const FRONTEND_BUILT_AT = process.env.REACT_APP_BUILD_TIME || null;
export const IS_DEV_SERVER = process.env.NODE_ENV === "development";

export const FRONTEND_REPO_URL = "https://github.com/sveerendharreddy/iotrips.in";
export const BACKEND_REPO_URL = "https://github.com/sveerendharreddy/iotrips_backend";
